import { useFormik } from "formik";
import $ from "jquery";
import moment from "moment";
import React, { useCallback, useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";
import LOGO from "../assets/images/Globelink.png";
import {
  fetchFieldExecByIdThunk,
  generateMandateTokenThunk,
  getMandateAmountThunk,
  updateFieldExecByIdThunk,
} from "../redux/features/mandateSlice";
import {
  formatDebitDate,
  generateConsumerId,
  generateTransactionId,
  getEndDate,
} from "../utils/utilsFunction";

const MandateFailure = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const [fieldExecutiveData, setFieldExecutiveData] = useState(null); // Initialize as null
  const [mandateAmt, setMandateAmt] = useState();
  const formValuesRef = useRef(null);

  const handleResponse = useCallback(
    async (res) => {
      if (res?.paymentMethod?.paymentTransaction?.statusCode) {
        const statusCode = res.paymentMethod.paymentTransaction.statusCode;
        console.log("Payment Response:", res);

        switch (statusCode) {
          case "0300":
            console.log("Transaction Successful");
            break;

          case "0398":
            console.log("Transaction Initiated");
            const mandateDetails = {
              id: fieldExecutiveData.mandate_id._id,
              mandateRegNo:
                res.paymentMethod.paymentTransaction.instruction?.id || "",
              responseCode: res.paymentMethod.paymentTransaction.statusCode,
              responseMessage:
                res.paymentMethod.paymentTransaction.statusMessage || "",
              responseStatus: "Initiated",
              transactionId:
                res.paymentMethod.paymentTransaction.txnId ||
                formValuesRef.current.transactionId,
              consumerId:
                res.paymentMethod.paymentTransaction.consumerId ||
                formValuesRef.current.consumerId,
              accountName: formValuesRef.current.accountName,
              accountNo: formValuesRef.current.accountNo,
              ifscCode: formValuesRef.current.ifscCode,
              maxAmount: mandateAmt,
              debitStartDate: moment().format("YYYY-MM-DD"),
              debitEndDate: moment()
                .add(40, "years")
                .subtract(3, "days")
                .startOf("day")
                .format("YYYY-MM-DD"),
            };

            dispatch(updateFieldExecByIdThunk(mandateDetails)).then((data) => {
              if (data.meta.requestStatus === "fulfilled") {
                toast.success("Mandate Update Successfully");
                navigate("/");
              }
            });
            break;

          default:
            console.error("Transaction Failed", res);
            toast.error("Bank mandate registration failed");
        }
      } else {
        console.error("Invalid Response", res);
        toast.error("Invalid response from bank");
      }
    },
    [dispatch, fieldExecutiveData, navigate, mandateAmt]
  );

  // const mandate = useCallback(async () => {
  //   if (!isScriptLoaded) {
  //     console.log("Script not loaded yet");
  //     toast.error("Payment gateway script not loaded yet");
  //     return;
  //   }

  //   if (!fieldExecutiveData || hasMandateRun) {
  //     console.log("Mandate already ran or data not ready");
  //     return; // Prevent re-running
  //   }

  //   try {
  //     const requiredMandateDetails = {
  //       consumerId: generateConsumerId(),
  //       transactionId: generateTransactionId(),
  //       accountName:
  //         fieldExecutiveData.mandate_id.bankDetails.accountHolderName,
  //       accountNo: fieldExecutiveData.mandate_id.bankDetails.accountNumber,
  //       ifscCode: fieldExecutiveData.mandate_id.bankDetails.ifscCode,
  //       maxAmount: "200",
  //       debitStartDate: formatDebitDate(Date.now()),
  //       debitEndDate: getEndDate(Date.now()),
  //     };

  //     // Update state only once and avoid re-triggering mandate
  //     if (!fieldExecutiveData.transactionId) {
  //       setFieldExecutiveData((prev) => ({
  //         ...prev,
  //         transactionId: requiredMandateDetails.transactionId,
  //         consumerId: requiredMandateDetails.consumerId,
  //         maxAmount: requiredMandateDetails.maxAmount,
  //         debitStartDate: requiredMandateDetails.debitStartDate,
  //         debitEndDate: requiredMandateDetails.debitEndDate,
  //       }));
  //     }

  //     const response = await dispatch(
  //       generateMandateTokenThunk(requiredMandateDetails)
  //     );

  //     const token = response.payload.token;

  //     if (!token) {
  //       toast.error("Failed to generate mandate token");
  //       return;
  //     }

  //     const configJson = {
  //       features: {
  //         showPGResponseMsg: true,
  //         enableAbortResponse: true,
  //         enableNewWindowFlow: true,
  //         enableExpressPay: true,
  //         siDetailsAtMerchantEnd: true,
  //         enableSI: true,
  //       },
  //       consumerData: {
  //         deviceId: "WEBSH2",
  //         token: token,
  //         returnUrl: "",
  //         responseHandler: handleResponse,
  //         paymentMode: "netBanking",
  //         merchantLogoUrl: LOGO,
  //         merchantId: "T906797",
  //         currency: "INR",
  //         consumerId: requiredMandateDetails.consumerId,
  //         txnId: requiredMandateDetails.transactionId,
  //         items: [{ itemId: "first", amount: "1", comAmt: "0" }],
  //         customStyle: {
  //           PRIMARY_COLOR_CODE: "#75000e",
  //           SECONDARY_COLOR_CODE: "#E9E9E9",
  //           BUTTON_COLOR_CODE_1: "#012647",
  //           BUTTON_COLOR_CODE_2: "#FFFFFF",
  //         },
  //         accountNo: requiredMandateDetails.accountNo,
  //         accountHolderName: requiredMandateDetails.accountName,
  //         ifscCode: requiredMandateDetails.ifscCode,
  //         accountType: "Saving",
  //         debitStartDate: requiredMandateDetails.debitStartDate,
  //         debitEndDate: requiredMandateDetails.debitEndDate,
  //         maxAmount: requiredMandateDetails.maxAmount,
  //         amountType: "M",
  //         frequency: "ADHO",
  //       },
  //     };

  //     if (window.$.pnCheckout) {
  //       window.$.pnCheckout(configJson);
  //       if (configJson.features.enableNewWindowFlow) {
  //         window.pnCheckoutShared.openNewWindow();
  //       }
  //       setHasMandateRun(true); // Mark mandate as executed
  //     } else {
  //       toast.error("Payment gateway is not available");
  //     }
  //   } catch (error) {
  //     toast.error("Failed to initiate bank selection");
  //     console.error("Error:", error);
  //   }
  // }, [
  //   fieldExecutiveData,
  //   isScriptLoaded,
  //   hasMandateRun,
  //   dispatch,
  //   handleResponse,
  // ]);

  const executiveFormik = useFormik({
    initialValues: {
      accountName:
        fieldExecutiveData?.mandate_id?.bankDetails?.accountHolderName,
      accountNo: fieldExecutiveData?.mandate_id?.bankDetails?.accountNumber,
      ifscCode: fieldExecutiveData?.mandate_id?.bankDetails?.ifscCode,
    },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      accountName: Yup.string()
        .required("Account Name is required")
        .min(2, "Account name must be at least 2 characters"),
      accountNo: Yup.string()
        .required("Account Number is required")
        .matches(
          /^\d{9,18}$/,
          "Account number must be between 9 and 18 digits"
        ),
      ifscCode: Yup.string()
        .required("IFSC Code is required")
        .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC code format"),
    }),

    onSubmit: async (values) => {
      try {
        const requiredMandateDetails = {
          consumerId: generateConsumerId(),
          transactionId: generateTransactionId(),
          accountName: values.accountName,
          accountNo: values.accountNo,
          ifscCode: values.ifscCode,
          maxAmount: mandateAmt,
          debitStartDate: formatDebitDate(Date.now()),
          debitEndDate: getEndDate(Date.now()),
        };

        formValuesRef.current = requiredMandateDetails;

        console.log(requiredMandateDetails, "configJson");
        const response = await dispatch(
          generateMandateTokenThunk(requiredMandateDetails)
        );

        // Check if response has the token
        const token = response.payload.token;

        if (!token) {
          console.error("Token generation failed.");
          return;
        }
        // Check if pnCheckout is available on window
        if (typeof window.$.pnCheckout === "undefined") {
          console.error("pnCheckout is not available on window.$");
          return;
        }
        // Prepare the configuration for the payment
        const configJson = {
          features: {
            showPGResponseMsg: true,
            enableAbortResponse: true,
            enableNewWindowFlow: true, //for hybrid applications please disable this by passing false
            enableExpressPay: true,
            siDetailsAtMerchantEnd: true,
            enableSI: true,
          },
          consumerData: {
            deviceId: "WEBSH2",
            token: token,
            returnUrl: "",
            responseHandler: handleResponse,
            paymentMode: "netBanking",
            merchantLogoUrl: LOGO,
            merchantId: "L906797",
            currency: "INR",
            consumerId: requiredMandateDetails.consumerId,
            txnId: requiredMandateDetails.transactionId,
            items: [
              {
                itemId: "first",
                amount: "1",
                comAmt: "0",
              },
            ],
            customStyle: {
              PRIMARY_COLOR_CODE: "#75000e",
              SECONDARY_COLOR_CODE: "#E9E9E9",
              BUTTON_COLOR_CODE_1: "#012647",
              BUTTON_COLOR_CODE_2: "#FFFFFF",
            },
            accountNo: requiredMandateDetails.accountNo,
            accountHolderName: requiredMandateDetails.accountName,
            ifscCode: requiredMandateDetails.ifscCode,
            accountType: "Saving",
            debitStartDate: requiredMandateDetails.debitStartDate,
            debitEndDate: requiredMandateDetails.debitEndDate,
            maxAmount: requiredMandateDetails.maxAmount,
            amountType: "M",
            frequency: "ADHO",
          },
        };

        console.log(configJson, "hereeeeeee.................");

        // Trigger the Worldline checkout flow
        window.$.pnCheckout(configJson);
        if (configJson.features.enableNewWindowFlow) {
          window.pnCheckoutShared.openNewWindow();
        }
      } catch (error) {
        console.error(
          "Error during token generation or payment initiation:",
          error
        );
      }
    },
  });

  const getMandateAmount = useCallback(() => {
    dispatch(getMandateAmountThunk({})).then((data) => {
      if (data.meta.requestStatus === "fulfilled") {
        setMandateAmt(data.payload.data.amount);
      } else {
        toast.error(data.payload);
      }
    });
  }, [dispatch, setMandateAmt]);

  useEffect(() => {
    getMandateAmount();
  }, [getMandateAmount]);

  // Load jQuery and Paynimo script only once
  useEffect(() => {
    console.log("Loading script...");
    window.$ = window.$ || $;
    window.jQuery = window.jQuery || $;

    const existingScript = document.querySelector(
      'script[src="https://www.paynimo.com/Paynimocheckout/server/lib/checkout.js"]'
    );
    if (!existingScript) {
      const script = document.createElement("script");
      script.src =
        "https://www.paynimo.com/Paynimocheckout/server/lib/checkout.js";
      script.async = true;
      script.onload = () => {
        console.log("Checkout.js loaded successfully");
      };
      script.onerror = () => {
        console.error("Failed to load Checkout.js");
      };
      document.body.appendChild(script);

      return () => {
        if (document.body.contains(script)) {
          document.body.removeChild(script);
        }
      };
    }
  }, []); // Runs once on mount

  // Fetch field executive data
  useEffect(() => {
    dispatch(fetchFieldExecByIdThunk(params.id)).then((data) => {
      if (data.meta.requestStatus === "fulfilled") {
        setFieldExecutiveData(data.payload.data);
        if (
          data.payload.data.mandate_id.mandateDetails.registrationStatus !==
          "Failed"
        ) {
          toast.error("Mandate Not Failed");
          navigate("/");
        }
      } else {
        toast.error(data.payload);
        navigate("/");
      }
    });
  }, [dispatch, params, navigate]); // Only re-run if params or dispatch changes

  // Trigger mandate when conditions are met
  // useEffect(() => {
  //   if (fieldExecutiveData && isScriptLoaded && !hasMandateRun) {

  //   }
  // }, [fieldExecutiveData, isScriptLoaded, hasMandateRun, mandate]);

  return (
    <div
      className="w-full min-h-screen flex items-center justify-center relative overflow-y-auto"
      style={{
        background: `linear-gradient(135deg, #67221A 50%, #FFFFFF 50%)`,
      }}
    >
      <div className="w-full max-w-4xl p-4 md:p-6 lg:p-8 bg-white rounded-lg shadow-lg z-10">
        <form onSubmit={executiveFormik.handleSubmit}>
          <fieldset className="border border-[#67221A] rounded p-4">
            <legend className="text-[#67221A] font-semibold px-2">
              Mandate Details
            </legend>
            <div className="grid grid-cols-4 md:grid-cols-4 gap-4 pb-4">
              <div className="col-span-4">
                <label
                  htmlFor="accountName"
                  className="block text-[#67221A] font-semibold mb-1"
                >
                  Account Name
                </label>
                <input
                  id="accountName"
                  name="accountName"
                  type="text"
                  value={executiveFormik.values.accountName}
                  onChange={executiveFormik.handleChange}
                  onBlur={executiveFormik.handleBlur}
                  className="col-span-2 w-full p-2 border border-gray-300 rounded text-black focus:outline-none focus:ring-2 focus:ring-[#67221A]"
                />
                {executiveFormik.touched.accountName &&
                  executiveFormik.errors.accountName && (
                    <div className="text-[#75000e] text-sm mt-1">
                      {executiveFormik.errors.accountName}
                    </div>
                  )}
              </div>
              <div className="col-span-2">
                <label
                  htmlFor="accountNo"
                  className="block text-[#67221A] font-semibold mb-1"
                >
                  Account No
                </label>
                <input
                  id="accountNo"
                  name="accountNo"
                  type="text"
                  value={executiveFormik.values.accountNo}
                  onChange={executiveFormik.handleChange}
                  onBlur={executiveFormik.handleBlur}
                  className="col-span-2 w-full p-2 border border-gray-300 rounded text-black focus:outline-none focus:ring-2 focus:ring-[#67221A]"
                />
                {executiveFormik.touched.accountNo &&
                  executiveFormik.errors.accountNo && (
                    <div className="text-[#75000e] text-sm mt-1">
                      {executiveFormik.errors.accountNo}
                    </div>
                  )}
              </div>
              <div className="col-span-2">
                <label
                  htmlFor="ifscCode"
                  className="block text-[#67221A] font-semibold mb-1"
                >
                  IFSC Code
                </label>
                <input
                  id="ifscCode"
                  name="ifscCode"
                  type="text"
                  value={executiveFormik.values.ifscCode}
                  onChange={executiveFormik.handleChange}
                  onBlur={executiveFormik.handleBlur}
                  className="w-full p-2 border border-gray-300 rounded text-black focus:outline-none focus:ring-2 focus:ring-[#67221A]"
                />
                {executiveFormik.touched.ifscCode &&
                  executiveFormik.errors.ifscCode && (
                    <div className="text-[#75000e] text-sm mt-1">
                      {executiveFormik.errors.ifscCode}
                    </div>
                  )}
              </div>
            </div>
          </fieldset>
          <div className="flex justify-between mt-6">
            <button
              type="submit"
              className={`bg-[#67221A] text-white rounded-3xl px-4 py-2 font-semibold  hover:bg-[#012647]`}
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MandateFailure;
